import { getContractABI, getContractAddress } from "../utils/abiHelper";
import { getWeb3IfAvailable, parseError } from "../web3Utils";
import { ContractService } from "./ContractService";

export class BinanceSwapService extends ContractService{

    constructor(args = {}) {
        super();
        this.contractType = 'BinanceSwap'
        this.abi = getContractABI(this.contractType);
        this.addHooks();
    }

    async preHook() {
        this.web3 = await getWeb3IfAvailable()
        this.accounts = await this.web3.eth.getAccounts();
        this.contractAddress = await getContractAddress(this.contractType);
        this.contractInstance = new this.web3.eth.Contract(
            this.abi,
            this.contractAddress
        );
    }

    async getPaymentStatus(tokenId) {
        return this.contractInstance.methods.getPaymentStatus(tokenId).call();
    }

    async getContractInfo() {
        return this.contractInstance.methods.getContractInfo().call();
    }

    async swap({
        swappableTokenId 
    }) {
        try {
            const gasPrice = await this.web3.eth.getGasPrice();


            let args = [
                Number(swappableTokenId)
            ], options = {
                gasPrice,
                from: this.accounts[0]
            };

            const paymentStatus = await this.getPaymentStatus(swappableTokenId);
            console.log('paymentStatus', paymentStatus)
            if(!paymentStatus) {
                const contractInfo = await this.getContractInfo();
                console.log('contractInfo.transactionFee', contractInfo.transactionFee);
                options['value'] = contractInfo.transactionFee;
            }

            const estimatedGas = await this.contractInstance
                .methods
                .swap( ...args)
                .estimateGas(options);
             
            options['gas'] = estimatedGas + 5000;
            await this.contractInstance
                .methods
                .swap( ...args )
                .send(options);
        } catch(err) {
            console.log('err', err);
            throw parseError(err);
        }
        return 'Token swapped successfully!';
    }
    
}